import { render, staticRenderFns } from "./add_on_settings.vue?vue&type=template&id=617b0c94&scoped=true&"
import script from "./add_on_settings.vue?vue&type=script&lang=js&"
export * from "./add_on_settings.vue?vue&type=script&lang=js&"
import style0 from "./add_on_settings.vue?vue&type=style&index=0&id=617b0c94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b0c94",
  null
  
)

export default component.exports